export const config = {
  app: {
    version: process.env.REACT_APP_VERSION
      ? process.env.REACT_APP_VERSION
      : "",
    room: {
      name: process.env.REACT_APP_ROOM_TITLE
      ? process.env.REACT_APP_ROOM_TITLE
      : "ROOM管理画面",
    },
    expo: {
      name: process.env.REACT_APP_EXPO_TITLE
      ? process.env.REACT_APP_EXPO_TITLE
      : "BRIDGE VR展示会",
    }
  },
  api: {
    rootUrl: process.env.REACT_APP_API_ROOT_URL,
  },
  list: {
    pageSizeOptions: [10, 20, 50, 100],
    search: {
      userTypeList: [
        {
          label: '全て',
          value: ''
        },
        {
          label: 'ROOM',
          value: 'room'
        },
        {
          label: '展示会',
          value: 'expo'
        },
      ]
    },
  },
  expo: {
    url: process.env.REACT_APP_EXPO_URL,
    prefix: process.env.REACT_APP_EXPO_URL_PREFIX,
    notice: {
      url: process.env.REACT_APP_EXPO_NOTICE_URL,
    },
  },
  room: {
    page: {
      release: {
        url: process.env.REACT_APP_ROOM_PAGE_RELEASE_URL,
      },
      preview: {
        url: process.env.REACT_APP_ROOM_PAGE_PREVIEW_URL,
      }
    },
    file: {
      threeDModel: {
        url: process.env.REACT_APP_ROOM_FILE_3D_MODEL_URL,
      },
      balloonChatScenario: {
        url: process.env.REACT_APP_ROOM_FILE_BALOON_CHAT_SCENARIO_URL,
      }
    },
    account: {
      salesman: {
        userTypeList: [
          {
            label: 'ROOM',
            value: 1
          },
          {
            label: '展示会',
            value: 3
          },
        ]
      }
    }
  },
  task:{
    pathNames: ['tasklist','roomattachfile','roommember']
  },
  gcs: {
    bucket: {
      menuMaterial: process.env.REACT_APP_GCS_BUCKET_MENU_MATERIAL
    }
  },
};
